<div class="near-search__loading">
    <div class="near-search__loading-spinner">
      <div class="near-search__loading-spinner-item"></div>
      <div class="near-search__loading-spinner-item"></div>
      <div class="near-search__loading-spinner-item"></div>
    </div>
</div>